import React from 'react';

const ProjectDescription = function(props) {
  return (
    <div>
      <p>
        A beautiful flint threshing barn, with a vaulted, narrow main space and
        chunky oak roof structure, is to be renovated to become a wedding venue
        and function space in the Suffolk countryside.
      </p>
      <p>
        The main threshing barn will be sensitively renovated, with new plain
        tile roofs and localised repairs to the existing masonry, as a simple
        backdrop to events. Accompanying the main barn will be a new
        timber-framed building to allow visitors to mingle with fizz and
        Canapés, while changes are made to the function of the barn (ceremony,
        breakfast, and reception, for example).
      </p>
      <p>
        By introducing the new building in parallel to the hall, an open
        courtyard is created for summer events, with a lightweight steel frame
        between creating a frame for canopies and lighting. The new building
        will also carefully control views to allow the activities of the working
        farm behind to continue without disturbing or disrupting the functions
        within.
      </p>
    </div>
  );
}

export default ProjectDescription;



// WEBPACK FOOTER //
// ./src/components/projects/hall-farm-threshing-barn.jsx